import { title } from "process"

export interface DataType {
  id: number,
  name: string,
  description: string,
  status: number,
  startDate: string,
  endDate: string,
  imageUrl: string,
  cycle: number,
  cycleTotal: number
}

export const column = [
    {
        title: '权益包编号',
        dataIndex: 'id',
        key: 'id',
        width: 100,
      },
      {
        title: '权益包标题',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '总周期数',
        dataIndex: 'cycleTotal',
        key: 'cycleTotal',
        width: 100,
      },
      // {
      //   title: '权益包周期',
      //   dataIndex: 'cycle',
      //   key: 'cycle',
      // },
      // {
      //   title: '渠道',
      //   dataIndex: 'supplyChannelName',
      //   key: 'supplyChannelName',
      // },
      {
        title: '参与人数',
        dataIndex: 'participants',
        key: 'participants',
        width: 100,
      },
      // {
      //   title:'延迟领取时间(小时)',
      //   dataIndex: 'delayCollectionDay',
      //   key: 'delayCollectionDay',
      //   width: 80,
      // }
]